import ErankLogo from './ErankLogo.vue';

export default ErankLogo;
